import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import styles from './Layout.module.css';

const Layout: React.FC = () => {
  const { theme, sidebarOpen } = useSelector((state: RootState) => state.layout);
  
  return (
    <div className={`${styles.layout} ${styles[theme]}`}>
      <Header />
      <div className={styles.container}>
        <Sidebar />
        <main className={`${styles.main} ${sidebarOpen ? styles.mainShifted : ''}`}>
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout; 